import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { SchedulerBaseService } from "./scheduler.base.service";
import { getAvailableTimeSlotsPayload } from "app/models/booking-page.model";

@Injectable({
  providedIn: "root",
})
export class sessiondaytimeslotsService extends SchedulerBaseService {

  constructor(public provider: ServiceProvider) {
    super("api/session-day-time-slots", provider);
  }

  public updateSlot(data) {
   return this.update(data)
  }

  public getSlots(data: getAvailableTimeSlotsPayload, url){
    return this.save(data,url);
  }

}